import type { ApolloClient } from "@apollo/client";
import { getApi } from "./api";

export const getTestTurtleClient = (): ApolloClient => getApi().getTestTurtleClient();
export const getDeployDuckClient = (): ApolloClient => getApi().getDeployDuckClient();

export const getPlatformPlatypusClient = (): ApolloClient => getApi().getPlatformPlatypusClient();
